import { render, staticRenderFns } from "./customerCase.vue?vue&type=template&id=441f2a08&scoped=true&"
import script from "./customerCase.vue?vue&type=script&lang=js&"
export * from "./customerCase.vue?vue&type=script&lang=js&"
import style0 from "./customerCase.vue?vue&type=style&index=0&id=441f2a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f2a08",
  null
  
)

export default component.exports